/* istanbul ignore next */
const styles = {
  container: {
    display: 'inline-block',
    verticalAlign: 'middle',
    position: 'relative'
  },
  hidden: {
    position: 'absolute',
    width: '100%',
    height: 16,
    opacity: 0,
    cursor: 'pointer',
    marginTop: '0 !important'
  },
  icon: {
    fill: 'none',
    stroke: '#ffffff',
    strokeWidth: 2.5
  },
  styledCheckbox: {
    display: 'inline-block',
    cursor: 'pointer',
    width: 16,
    height: 16,
    background: '#ffffff',
    border: '1px solid #4c4c4c',
    borderRadius: 3,
    transition: 'all 150ms',
    '&.disabled': {
      opacity: 0.2,
      cursor: 'not-allowed'
    },
    '&.checked': {
      background: '#4c4c4c',
      borderColor: 'transparent',
      '& > svg': {
        visibility: 'visible'
      }
    },

    '& + label': {
      marginLeft: 5,
      marginBottom: 0,
      fontWeight: 'normal'
    }
  }
};

export default styles;
